exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nlabel[data-v-a06cf5e8] {\n    padding-top: 0;\n    padding-bottom: 0;\n    vertical-align: bottom;\n}\nth[data-v-a06cf5e8], td[data-v-a06cf5e8] {\n    vertical-align: middle;\n    padding-top: 0;\n    padding-bottom: 0;\n}\n", ""]);

// exports
